import React from 'react';

export default class PeopleListCard extends React.Component {

  render() {
    const pictureUrl = (this.props.person.pictureUrl === '')
      ? '../../assets/img/avatar-gray-list.jpg'
      : this.props.person.pictureUrl
    ;
    const backgroundImageCss = `url(${pictureUrl})`;

    return (
      <div className="PeopleListCard" onClick={() => this._cardClicked() }>
        <div className="card">
          <div className="picture-container">
            <div className="picture" style={ { 'backgroundImage': backgroundImageCss } }></div>
          </div>
          <div className="meta">
            <div className="cell">
              <span className="name"><strong>{this.props.person.name}</strong></span>
              <span className="jobtitle">{this.props.person.jobTitle}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _cardClicked() {
    this.props.actions.open(this.props.index);
  }

};
